var $ = require('jquery')
  , renderProfileRank = require('game-info/sections/profile/renderProfileRank')
  , renderDownload = require('./renderDownload')
  , voteGame = require('mobile/widgets/voteGame')
  , ajaxIsUserScheGame = require('apis/ajaxIsUserScheGame')
  , makeFixed = require('mobile/widgets/makeFixed')

$(function() {

  var section = $('.area-mater')
  if (!section.length) { return }

  section.on( 'click', '.btn-vote-current-game', function() {
    voteGame(ued.gameCode)
  });

  // 只有手游或者多平台才去渲染这个模块
  if (!ued.isOnlineGame || (ued.isOnlineGame && ued.isSteam)) {
    renderDownload(section)
  }

  if (!ued.isOffLine) {
    renderProfileRank(section)
  } else {
    // renderCherishNumber(section)
  }

  var buttonBeSticky = section.find('.mod-mater-quick-channel')
  if (buttonBeSticky.length) {
    makeFixed(buttonBeSticky)
  }

  var buttonEngageGame = section.find('.btn-engage-current-game')
  if (Passport.data('uid') != '' && buttonEngageGame.length) {
    ajaxIsUserScheGame(ued.gameCode, Passport.data('uid'))
      .done(function(isFollowed) {
        if (isFollowed) {
          // 遍历每个按钮，根据其类型设置不同的文本
          buttonEngageGame.each(function() {
            var $this = $(this);
            var btnText = '已预定';
            
            // 只有带有 btn-follow-current-game 类的元素才会显示"已关注"
            if ($this.hasClass('btn-follow-current-game')) {
              btnText = '已关注';
            }
            
            $this.addClass('disable')
              .removeClass('btn-engage-current-game')
              .text(btnText);
          });
        }
      })
  }
})
